/* eslint-disable no-eval */
import React, { useState } from "react";
import { filterOptions, showHideForm, _checkValue, getImageUploadEditValue, MAX_COMMENTS_LENGTH, MAX_TEXT_AREA_LENGTH, getMetaPlaceholer, MAX_TEXT_INPUT_LENGTH } from '../../helpers/form';
import { Form, Input, Select, DatePicker, InputNumber, Space, Button, Switch, Upload, Radio, Checkbox, Popover, Popconfirm } from "antd";
import { PlusOutlined, DeleteOutlined, WarningFilled, InboxOutlined } from '@ant-design/icons';
import { filterSelectOptions } from 'datastake-daf/src/helpers/Forms';
import i18next from "i18next";
import _ from 'lodash';
import 'moment/locale/fr';
import localeEn from 'antd/es/date-picker/locale/en_US';
import localeFr from 'antd/es/date-picker/locale/fr_FR';
import moment from 'moment';
import dot from 'dot-object';
import ReactHtmlParser from 'react-html-parser';

import { PhoneInputAnt } from "../../components/Inputs";
import Geolocation from './components/geolocation';
import { deepFind } from "../../helpers/deepFind";
import AjaxSelect from './components/ajaxSelect';
import AjaxModal from './components/AjaxModal';
import Transfer from './components/Transfer';
import Tag from "./components/tag";
import Website from "../../components/Inputs/Website";
import { countries } from "countries-list";
import GroupInput from "./components/groupInput";
import { numberWithCommas } from "../../components/DynamicViewNew/helper";
import { Template } from "./templates";
import { getSelectOptions, propHasValue } from "../../components/DynamicFormNew/helper";
import { colors } from "../View/templates/components/risk/riskEvolution";
import EditSelect from "./components/Select";
import { getToken } from 'datastake-daf/src/helpers/Token';
import { getPopupContainer } from "../../helpers/popUp";
import dayjs from "dayjs";
import TooltipIcon from "../../components/dashboards/components/TooltipIcon";
import { formatClassname } from "datastake-daf/src/helpers/ClassesHelper";
import { CustomIcon } from "datastake-daf/dist/components";
import { getAppHeader, getApiBaseUrl } from "../../services/BaseService";
import DataLink from "./components/DataLink";
import { getLabel } from "../ViewTIF/components/input";

const smMtInputs = ['switch'];

export const getDefaultInputValue = (input = {}) => {
  let value = undefined;

  if (input.type === 'multiselect') {
    value = [];
  }

  return value;
}

export const renderPolygons = ({ value, color }) => (
  <div className="polygons">
    {[5, 4, 3, 2, 1].map((k) => (
      <svg key={`polygons-${k}`} width="12" height="12" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.78519 3.91688L5.97677 7.00876L2.35993 7.00876L0.551515 3.91688L2.35993 0.824996L5.97677 0.824996L7.78519 3.91688Z"
          fill={k <= value ? color : '#F4F4F4'}
        />
      </svg>
    ))}
  </div>
);

export const checkCondition = (condition, repeatValues, formsValue) => {
  let [field, match, wantedValue] = condition.split(/( is | includes | not | notEmpty | notOnly )/gmi);
  const isRepeatable = field.split('./').length > 1;
  const isNotEmpty = match === 'notEmpty';
  const formValue = isRepeatable ? repeatValues : formsValue;
  field = isRepeatable ? field.split('./')[1] : field;
  const value = deepFind(formValue, field);
  const isShown = _checkValue(
    isNotEmpty ? field : wantedValue,
    match,
    isNotEmpty ? formValue : value
  );
  return isShown;
}

export function showHideInput(input, data, repeatIndex, repeatValues, setValues, ref) {
  if (typeof input?.meta?.excludeFromEdit === 'boolean') {
    return !input?.meta?.excludeFromEdit;
  }

  const formsValue = { ...data };

  Object.keys(data?.meta?.inputs || {}).forEach((key) => {
    const input = data?.meta?.inputs[key];

    if (input.notApplicable || input.notAvailable) {
      formsValue[key] = undefined;
      delete formsValue[key];
    }
  });

  if (input.showIf) {
    const isOrCond = input.showIf.indexOf('OR') >= 0;
    const allParts = input.showIf.split(/( OR | && )/gmi).filter(c => !['OR', '&&'].includes(c.trim()));
    const parts = allParts.map(condition => {
      let [field, match, wantedValue] = condition.split(/( is | includes | not | notEmpty | notOnly | gte | gt | lte | lt )/gmi);
      match = match ? match.trim() : null;
      const isRepeatable = field.split('./').length > 1;
      const isNotEmpty = match === 'notEmpty';
      const formValue = isRepeatable ? repeatValues : formsValue;
      field = isRepeatable ? field.split('./')[1] : field;
      if (match && field.split('.').length > 1) {
        if (input.inputs) {
          const value = deepFind(formValue, field);
          const isShown = _checkValue(
            isNotEmpty ? field : wantedValue,
            match,
            isNotEmpty ? formValue : value
          );
          return isShown;
        } else {
          if ((isRepeatable ? !repeatValues : !formsValue)) {
            return false;
          } else {
            const value = deepFind(formValue, field);
            const isShown = _checkValue(
              isNotEmpty ? field : wantedValue,
              match,
              isNotEmpty ? formValue : value
            );
            return isShown;
          }
        }
      } else {
        const value = deepFind(formValue, field);

        if (match === 'gte') {
          return Number(formValue[field]) >= Number(wantedValue);
        }

        if (match === 'gt') {
          return Number(formValue[field]) > Number(wantedValue);
        }

        if (match === 'lte') {
          return Number(formValue[field]) <= Number(wantedValue);
        }

        if (match === 'lt') {
          return Number(formValue[field]) < Number(wantedValue);
        }

        const isShown = _checkValue(
          isNotEmpty ? field : wantedValue,
          match,
          isNotEmpty ? formValue : value
        );
        return isShown;
      }
    });
    const isShown = parts.length > 0 && ((isOrCond && parts.filter(p => p).length >= 1) || parts.filter(p => !p).length === 0);
    // if (!isShown && propHasValue(dot.pick(ref, formsValue)) && input.deleteDataOnHide !== false) {
    //   dot.delete(ref, formsValue);
    // }
    return isShown;
  }
  return true;
}

export function getInputData(name, input, value, commentValue, path, values) {
  const props = {
    placeholder: getInputLabel(input, values),
    valueplaceholder: input.valueLabel || null,
    disabled: input.disabled || false,
    accept: input.accept || undefined,
  }

  if (input.type === 'total100' && !value) {
    value = [{
      type: null,
      value: null
    }];
  } else if (['date', 'year'].includes(input.type)) {
    value = value ? dayjs(value) : undefined;
  } else if (input.type === 'switch') {
    if (!propHasValue(value)) {
      value = value || false;
      if (typeof path === 'string') {
        dot.str(path, value, values);
      }
    }
  }

  const config = {
    name,
    call: input.call,
    getFromLinking: input?.meta?.getFromLinking,
    automaticallyLink: input.automaticallyLink,
    props,
    formsValue: values,
    onNewSetValue: input.onNewSetValue,
    multiple: input.multiple,
    updateOptions: input.updateOptions || false,
    options: input.options,
    optionsFilter: input?.meta?.optionsFilter,
    filterCond: input.filterCond,
    disableOtherFields: input.disableOtherFields,
    updateOtherFields: input.updateOtherFields,
    repeatLabel: input.repeatLabel,
    unique: input.unique,
    totalMax: input.totalMax,
    modalTitle: input.modalTitle,
    buttonText: input.buttonText,
    value,
    commentValue,
    commentHint: input.commentHint ? input.commentHint : i18next.t('Please specify'),
    rules: (input.rules || []).map(r => {
      if (r.message && r.message.indexOf('errors::') >= 0) {
        r.message = i18next.t(r.message);
      }
      return r;
    }),
  }
  if (input.type === 'switch' && input.autocomplete) {
    Object.assign(config, { autocomplete: input.autocomplete });
  }
  if (input.type === 'switch') {
    if (input.replace) {
      Object.assign(config, { replace: input.replace });
    }
    if (input.unique) {
      Object.assign(config, { unique: input.unique });
    }
  }
  if (input.type === 'linkingModal') {
    Object.assign(config, {
      content: input.inputs
    });
  }

  return config;
}
export function getInputHeadLines(type, i, input, values) {
  switch (type) {
    case 'h2':
      return <div className={`title-semibold-2 ${input.marginBottom || ''} ${input.groupHeader || ''} ${i ? (input.marginTop || '') : ''}`}>
        <span>{getInputLabel(input, values)}</span>
      </div>
    case 'h3':
      return <div className={`title-semibold-3 ${input.marginBottom || ''} ${input.groupHeader || ''} ${i ? (input.marginTop || '') : ''}`}>
        <span>{getInputLabel(input, values)}</span>
      </div>
    case 'h4':
      return <div className={`title-semibold-4 ${input.marginBottom || ''} ${input.groupHeader || ''} ${i ? (input.marginTop || '') : ''}`}>
        <span>{getInputLabel(input, values)}</span>
      </div>
    case 'h5':
      return <div className={`title-semibold-5 ${input.marginBottom || ''} ${input.groupHeader || ''} ${i ? (input.marginTop || '') : ''}`}>
        <span>{getInputLabel(input, values)}</span>
      </div>
    case 'h6':
      return <div className={`title-semibold-6 ${input.marginBottom || ''} ${input.groupHeader || ''} ${i ? (input.marginTop || '') : ''}`}>
        <span>{getInputLabel(input, values)}</span>
      </div>
    default:
      return null;
  }
}
export function getInputProp(prop, formsValue = {}) {
  if (prop && typeof prop === 'object') {
    const validations = Object.keys(prop);
    const key = validations.find(v => {
      let [path, match, wantedValue] = v.split(/( is | includes | not | notEmpty )/gmi);
      const value = dot.pick(path, formsValue);
      return _checkValue(wantedValue, match, value)
    });
    const label = key ? prop[key] : prop[validations[0]];
    return label;
  } else {
    return prop;
  }
}
export function getInputLabel(input, formsValue = {}, asText = false) {
  const label = getInputProp(input.label, formsValue);
  return input.description && typeof input.description === 'string' && !asText ? (
    <>
      <div className="flex">
        {(ReactHtmlParser(label))}
        <Popover
          content={(
            <div className="max-w-200">
              {input.description}
            </div>
          )}
          placement="top"
        >
          <div className="flex flex-column mt-1 ml-1">
            <TooltipIcon fontSize={13} />
          </div>
        </Popover>
      </div>
    </>
  ) : ReactHtmlParser(label)
}
export function getSectionLabel(labels, values) {
  if (typeof labels === 'object') {
    const validations = Object.keys(labels);
    const key = validations.find(v => {
      let [path, match, wantedValue] = v.split(/( is | includes | not | notEmpty )/gmi);
      const value = dot.pick(path, values);
      return _checkValue(wantedValue, match, value)
    });
    return key ? labels[key] : labels[validations[0]];
  }
  return labels;
}
export function getSubtitles(subtitles, position, formsValue = {}, repeatIndex, repeatValues) {
  let subtitle = subtitles && subtitles[position];
  if (subtitle && typeof subtitle === 'object') {
    let newSubtitle = subtitle.default || '';
    const subKeys = Object.keys(subtitle).filter(k => k !== 'default');
    let ind = 0;
    while (subKeys.length > ind) {
      const subKey = subKeys[ind];
      let [field, match, wantedValue] = subKey.split(/( is | includes | not | notEmpty )/gmi);
      match = match ? match.trim() : null;
      const isRepeatable = field.split('./').length > 1;
      const isNotEmpty = match === 'notEmpty';
      const formValue = isRepeatable ? repeatValues : formsValue;
      field = isRepeatable ? field.split('./')[1] : field;
      if (match && field.split('.').length > 1) {
        const value = deepFind(formValue, field);
        const isValid = _checkValue(
          isNotEmpty ? field : wantedValue,
          match,
          isNotEmpty ? formValue : value
        );
        if (isValid) {
          newSubtitle = subtitle[subKey];
          ind = subKeys.length;
        }
      } else {
        const value = deepFind(formValue, field);
        const isValid = _checkValue(
          isNotEmpty ? field : wantedValue,
          match,
          isNotEmpty ? formValue : value
        );
        if (isValid) {
          newSubtitle = subtitle[subKey];
          ind = subKeys.length;
        }
      }
      ind += 1;
    }
    subtitle = newSubtitle;
  }
  return subtitle
    ? <h5 className="title-semibold-5" style={{ margin: '0px 0px 10px 0px' }}>
      {subtitle}
    </h5> : null
}
export function getFormTitles(titles, key, position) {
  let tilte = titles && titles[key];
  return tilte
    ? <h3 className={`title-semibold-3 mb0 ${position ? 'mt-3' : ''}`}>
      {tilte}
    </h3> : null
}

export const checkForValueInOptions = (value, options) => {
  const option = options.find(o => o.value === value);
  if (option) {
    return value;
  }
  return undefined;
}
export const updateFormValues = (repeatIndex, repeatValues, inputName, value, formsValue, name, mainForm) => {
  formsValue = Object.assign(formsValue, {
    ...mainForm.getFieldsValue(true)
  });
  if (typeof repeatIndex === 'number' && repeatValues) {
    if (!repeatValues[inputName] || !_.isEqual(repeatValues[inputName], value)) {
      repeatValues[inputName] = value;
      if (!formsValue[name]) {
        formsValue[name] = [];
      }
      formsValue[name][repeatIndex] = repeatValues;
      mainForm.setFieldsValue({ [name]: formsValue[name] });
      mainForm.scrollToField([name, repeatIndex, inputName]);
    }
  } else {
    if (repeatValues && inputName !== name) {
      if (!repeatValues[inputName] || !_.isEqual(repeatValues[inputName], value)) {
        repeatValues[inputName] = value;
        formsValue[name] = repeatValues;
        mainForm.setFieldsValue({ [name]: formsValue[name] });
        mainForm.scrollToField([name, inputName]);
      }
    } else {
      if (!formsValue[name] || !_.isEqual(formsValue[name], value)) {
        mainForm.setFieldsValue({ [name]: value });
        mainForm.scrollToField(name);
      }
    }
  }
}
export const inputOnBlur = [];

export const inputTypeComponent = {
  text: ({ props, rules }, { inputMeta = {} }) => {
    const maxRule = rules.find(r => r.max);
    const maxProps = { maxLength: MAX_TEXT_AREA_LENGTH };

    if (maxRule) {
      maxProps.maxLength = maxRule.max;
    }

    return (
      <Input
        size="large"
        {...maxProps}
        allowClear
        autoComplete="new-password"
        type="text"
        {...props}
        disabled={props.disabled || inputMeta.notApplicable || inputMeta.notAvailable}
        placeholder={getMetaPlaceholer(inputMeta) || props.placeholder || i18next.t('Type')}
      />
    )
  },
  number: ({ props, rules }, { inputMeta = {} }) => {
    const maxRule = rules.find(r => r.max);
    if (maxRule) {
      return <InputNumber size="large" allowClear autoComplete="new-password" {...props} type="number" min={0} max={maxRule.max} />
    }
    return <InputNumber
      size="large"
      allowClear
      autoComplete="new-password"
      {...props}
      disabled={props.disabled || inputMeta.notApplicable || inputMeta.notAvailable}
      placeholder={getMetaPlaceholer(inputMeta) || props.placeholder || i18next.t('Type number')}
      min={0}
      formatter={value => numberWithCommas(value)}
      parser={value => value.replace(/\$\s?|(,*)/g, '')}
    />
  },
  select: ({ value, options, optionGroup, props, formsValue, optionsFilter, filterCond, repeatValues, repeatIndex, name, inputName, address, addressData }, { setFormValues, forms, allForms, form, setAddress, inputMeta = {} }) => {
    let opts;
    if (typeof options === 'string') {
      const [formName, key] = options.split('.');
      const values = formsValue[formName];
      if (values && Array.isArray(values)) {
        if (forms[formName]) {
          if (forms[formName].inputs[key].dataLink) {
            const dataLink = forms[formName].inputs[key].dataLink;
            return <EditSelect
              valueChangeKey={`${formName}-${key}-${inputName}`}
              value={values}
              formsValue={formsValue}
              filterSelectOptions={filterSelectOptions}
              address={address}
              addressData={addressData}
              props={props}
              setAddress={setAddress}
              keyy={key}
              values={values}
              dataLink={dataLink}
              update={(value) => {
                updateFormValues(repeatIndex, repeatValues, inputName, value, formsValue, name, form)
              }}
            />
          } else {
            opts = values.map(val => val[key]).filter(v => propHasValue(v)).map(v => {
              const iOptions = forms[formName].inputs[key].options || [];
              const iOption = iOptions.find(opt => opt.value === v);
              return {
                label: iOption ? iOption.label : v,
                value: iOption ? iOption.label : v,
              };
            });
          }
        }
      } else if (values && values[key]) {
        opts = [
          {
            label: values[key],
            value: values[key],
          }
        ]
      } else {
        opts = [];
      }
    } else {
      opts = options.filter(o => !o.onlyView);
    }
    opts = JSON.parse(JSON.stringify(opts || []));
    opts = opts.map(o => getSelectOptions(o, formsValue));
    if (optionsFilter && Array.isArray(optionsFilter)) {
      opts = filterOptions(opts, optionsFilter, formsValue, repeatValues, filterCond)
    }
    if (propHasValue(value)) {
      const selectOption = opts.find(o => o.value === value);
      if (!selectOption) {
        value = undefined;
        updateFormValues(repeatIndex, repeatValues, inputName, value, formsValue, name, form)
      }
    }
    if (optionGroup && Array.isArray(optionGroup) && optionGroup.length) {
      const gKeys = [];
      const groupOptions = optionGroup.map(o => {
        if (!gKeys.includes(o.value)) {
          gKeys.push(o.value);
        }
        return {
          label: o.label,
          items: opts.filter(op => op.group === o.value),
        }
      });
      const notGrouped = opts.filter(op => !gKeys.includes(op.group));
      if (notGrouped.length) {
        groupOptions.unshift(...notGrouped);
      }
      opts = groupOptions;
    }
    return <Select
      size="large"
      autoComplete="new-password"
      {...getPopupContainer()}
      allowClear
      showSearch
      filterOption={filterSelectOptions}
      optionFilterProp="children"
      {...props}
      disabled={props.disabled || inputMeta.notApplicable || inputMeta.notAvailable}
      placeholder={getMetaPlaceholer(inputMeta) || getInputProp(props.placeholder, formsValue) || i18next.t('Select one option')}
      onChange={(val, selectedValue) => {
        if (address && selectedValue) {
          dot.str(address, selectedValue.children, addressData);
          setAddress({
            ...addressData
          })
        }
        if (props.onChange) {
          props.onChange(val);
        }
      }}
    >
      {(opts || []).map((option, i) => {
        const otherProps = {};
        if (option.options) {
          Object.keys(option.options).forEach(prop => {
            if (eval(option.options[prop])) {
              Object.assign(otherProps, {
                [prop]: eval(option.options[prop])(value || [])
              });
            }
          });
        }
        return option.items ?
          <Select.OptGroup label={option.label}>
            {option.items.map((og, j) =>
              <Select.Option value={og.value} key={`${i}${j}`}>
                {og.label}
              </Select.Option>
            )}
          </Select.OptGroup> :
          <Select.Option value={option.value} key={option.value} {...otherProps}>
            {option.label}
          </Select.Option>
      })}
    </Select>
  },
  multiselect: ({ value, options, optionGroup, optionsFilter, filterCond, props, formsValue, repeatValues, repeatIndex, inputName, name, tags }, { forms, form, inputMeta = {} }) => {
    let opts;
    if (typeof options === 'string') {
      const [formName, key] = options.split('.');
      const values = formsValue[formName];
      if (values && Array.isArray(values)) {
        opts = values.map(val => val[key]).filter(v => propHasValue(v)).map(v => {
          const iOptions = forms[formName].inputs[key].options || [];
          const iOption = iOptions.find(opt => opt.value === v);
          return {
            label: iOption ? iOption.label : v,
            value: iOption ? iOption.label : v,
          };
        });
      } else if (values && values[key]) {
        opts = [
          {
            label: values[key],
            value: values[key],
          }
        ]
      } else {
        opts = [];
      }
    } else {
      opts = options;
    }
    opts = JSON.parse(JSON.stringify(opts));
    opts = opts.map(o => getSelectOptions(o, formsValue));
    if (optionsFilter && Array.isArray(optionsFilter)) {
      opts = filterOptions(opts, optionsFilter, formsValue, repeatValues, filterCond)
    }

    if (propHasValue(value) && Array.isArray(value) && value.length > 0) {
      try {
        const values = opts.filter(o => value.includes(o.value));
        if (propHasValue(values) && Array.isArray(values) && !(values.length === value.length)) {
          updateFormValues(repeatIndex, repeatValues, inputName, values.map(o => o.value), formsValue, name, form)
        }
      } catch {
      }
    }
    if (optionGroup && Array.isArray(optionGroup) && optionGroup.length) {
      const gKeys = [];
      const groupOptions = optionGroup.map(o => {
        if (!gKeys.includes(o.value)) {
          gKeys.push(o.value);
        }
        return {
          label: o.label,
          items: opts.filter(op => op.group === o.value),
        }
      });
      const notGrouped = opts.filter(op => !gKeys.includes(op.group));
      if (notGrouped.length) {
        groupOptions.unshift(...notGrouped);
      }
      opts = groupOptions;
    }

    return <Select
      size="large"
      allowClear
      {...getPopupContainer()}
      autoComplete="new-password"
      mode={tags ? "tags" : "multiple"}
      optionFilterProp="children"
      {...(tags ? { tokenSeparators: [','] } : {})}
      filterOption={filterSelectOptions}
      {...props}
      disabled={props.disabled || inputMeta.notApplicable || inputMeta.notAvailable}
      placeholder={getMetaPlaceholer(inputMeta) || getInputProp(props.placeholder, formsValue) || i18next.t('Select all relevant options')}
    >
      {(opts || []).map((option, i) => {
        const otherProps = {};
        if (option.options) {
          Object.keys(option.options).forEach(prop => {
            if (eval(option.options[prop])) {
              Object.assign(otherProps, {
                [prop]: eval(option.options[prop])(value || [])
              });
            }
          });
        }
        if (otherProps.disabled && (value || []).includes(option.value)) {
          updateFormValues(repeatIndex, repeatValues, inputName, (value || []).filter(v => v !== option.value), formsValue, name, form)
        }
        return option.items ?
          <Select.OptGroup label={option.label}>
            {option.items.map((og, j) =>
              <Select.Option value={og.value} key={`${i}${j}`}>
                {og.label}
              </Select.Option>
            )}
          </Select.OptGroup> :
          <Select.Option value={option.value} key={i} {...otherProps}>
            {option.label}
          </Select.Option>
      })}
    </Select>
  },
  date: ({ props, rules, repeatValues, formsValue }, { inputMeta }) => {
    const lng = localStorage.getItem('datastakeLng') || 'en';
    const maxRule = rules.find(r => r.max);
    if (maxRule) {
      let checkForMax = true;
      if (maxRule.condition) {
        checkForMax = checkCondition(maxRule.condition, repeatValues, formsValue)
      }
      if (checkForMax) {
        return <DatePicker
          size="large"
          allowClear
          autoComplete="new-password"
          {...props}
          disabled={props.disabled || inputMeta.notApplicable || inputMeta.notAvailable}
          placeholder={getMetaPlaceholer(inputMeta) || props.placeholder || i18next.t('Select date')}
          format="DD MMM YYYY"
          locale={lng === 'fr' ? localeFr : localeEn}
          disabledDate={(current) => {
            return current && current >= moment().endOf('day');
          }}

        />
      }
    }
    return <DatePicker
      size="large"
      allowClear
      autoComplete="new-password"
      {...props}
      disabled={props.disabled || inputMeta.notApplicable || inputMeta.notAvailable}
      placeholder={getMetaPlaceholer(inputMeta) || props.placeholder}
      format="DD MMM YYYY"
      locale={lng === 'fr' ? localeFr : localeEn}
    />
  },
  comment: ({ props: { placeholder, ...props }, commentHint }, { onChange, value }) => {
    return <Input.TextArea
      allowClear
      value={value}
      onChange={(e) => onChange(e.target.value)}
      maxLength={MAX_COMMENTS_LENGTH}
      placeholder={commentHint ? commentHint : placeholder}
      autoComplete="new-password"
      autoSize={{ minRows: 2, maxRows: 6 }}
      {...props}
      disabled={false}
    />
  },
  textarea: ({ props, rules }, { inputMeta }) => {
    const maxRule = rules.find(r => r.max);
    let maxLength = MAX_TEXT_AREA_LENGTH;
    let rows = 3;

    if (maxRule) {
      maxLength = maxRule.max;

      if (maxRule.max === 200) {
        rows = 3;
      }

      if (maxRule.max === 400) {
        rows = 6;
      }

      if (maxRule.max === 600) {
        rows = 9;
      }

      if (maxRule.max === 800) {
        rows = 11;
      }

      if (maxRule.max === 1000) {
        rows = 14;
      }
    }

    return (
      <Input.TextArea
        allowClear
        autoComplete="new-password"
        maxLength={maxLength}
        autoSize={{ minRows: rows, maxRows: rows }}
        {...props}
        disabled={props.disabled || inputMeta.notApplicable || inputMeta.notAvailable}
        placeholder={getMetaPlaceholer(inputMeta) || props.placeholder || i18next.t('Type')}
      />
    )
  },
  phoneNumber: ({ name, inputName, props, value, repeatIndex, repeatValues, formsValue, country }, { form, setFormValues }) => {
    return <PhoneInputAnt size="large" allowClear={true} country={country ? deepFind(formsValue, country) : null}
      initialValue={value}
      {...props} onChange={val => {
        if (repeatValues) {
          const inputValues = Array.isArray(formsValue[name]) ? (formsValue[name] || []) : [];
          if (!inputValues[repeatIndex]) {
            inputValues[repeatIndex] = {}
          }
          inputValues[repeatIndex][inputName] = val;
          // form.setFieldsValue({ [name]: inputValues });
          formsValue[name] = inputValues;
          setFormValues(formsValue);
        } else {
          // form.setFieldsValue({ [name]: val });
          formsValue[name] = val;
          setFormValues(formsValue);
        }
        return val;
      }} />
  },
  switch: ({ props, value, restricted, autocomplete, formsValue, repeatValues, repeatIndex, name, inputName, replace: replaceInput, unique }, { form, setFormValues, add, remove }) => {
    return <Switch
      {...props}
      size="default"
      className="switch"
      defaultChecked={value || false}
      checked={value || false}
      onChange={(isChecked) => {
        if (autocomplete) {
          Object.keys(autocomplete).forEach(fKey => {
            if (Object.keys(formsValue).includes(fKey)) {
              if (Array.isArray(formsValue[fKey])) {
                formsValue[fKey][0] = isChecked ? autocomplete[fKey] : undefined;
              } else {
                formsValue[fKey] = isChecked ? autocomplete[fKey] : undefined;
              }
            } else {
              form.setFieldsValue({ [fKey]: isChecked ? autocomplete[fKey] : undefined });
            }
          });
        }
        if (replaceInput) {
          const [replaceTo, replaceWith] = replaceInput.split('|');
          const oldId = dot.pick(replaceTo, formsValue);
          const newId = dot.pick(replaceWith, formsValue[name][repeatIndex]);
          const [formName, replaceInputName] = replaceTo.split('.');
          const replaceRepeatValues = replaceInputName ? dot.pick(formName, formsValue) : undefined;
          updateFormValues(undefined, replaceRepeatValues, replaceInputName, isChecked ? newId : undefined, formsValue, formName, form);
          formsValue = Object.assign(formsValue, {
            ...form.getFieldsValue(true)
          });
          if (oldId) {
            const allRepeatValues = dot.pick(name, formsValue);
            if (allRepeatValues && Array.isArray(allRepeatValues)) {
              const existOnRepeat = allRepeatValues.find(r => r[replaceWith] === oldId);
              if (!existOnRepeat) {
                updateFormValues(allRepeatValues.length, {}, replaceWith, oldId, formsValue, name, form);
              }
            }
          }
          // if (!formsValue[name].map(l => l.locationId).includes(oldId)) {
          //   add({ locationId: oldId, primary: false });
          //   remove(repeatIndex);
          // }
        }
        if (propHasValue(repeatIndex) && restricted) {
          if (formsValue[name].length > 1) {
            form.setFieldsValue({
              [name]: formsValue[name].map((input, i) => {
                if (i === repeatIndex) {
                  input[inputName] = value;
                } else {
                  input[inputName] = undefined;
                }
                return input;
              }),
            });
          }
        }
        updateFormValues(repeatIndex, repeatValues, inputName, isChecked, formsValue, name, form)
        if (unique && isChecked) {
          const allRepeatValues = dot.pick(name, formsValue);
          if (Array.isArray(allRepeatValues) && allRepeatValues.length > 1) {
            allRepeatValues.forEach((r, ind) => {
              if (ind !== repeatIndex) {
                updateFormValues(ind, r, inputName, false, formsValue, name, form)
              }
            })
          }
        }
      }} />
  },
  radioGroup: ({ props, value, options, restricted, autocomplete, formsValue, repeatIndex, name, inputName, replace, isRisk }, { form, setFormValues, add, remove, template }) => {
    if (isRisk) {
      return (
        <Radio.Group value={value} {...props} className="is-risk-radio">
          {(options || []).map(o => {
            return <Radio key={o.value} value={o.value}>
              <div className="radio-title">
                {o.label}
              </div>
              {o.description ? <div className="radio-description">
                {o.description}
              </div> : null}
            </Radio>
          })}
        </Radio.Group>
      );
    }
    switch (template) {
      case 'RISK':
        const title = inputName[0] + inputName.substring(1);
        const color = value ? colors[value] : '';
        const label = value ? (options.find((o) => o.value === parseInt(value)) || {}).label : '';
        return (
          <Radio.Group value={value} {...props}>
            <div className="risk-radio-group">
              <div className="info">
                <h4 className={`${value ? 'has-value' : 'no-value'}`}>{i18next.t(title)}</h4>
                {value ? (
                  <>
                    {renderPolygons({ value, color })}
                    <p className="description">{label}</p>
                  </>
                ) : (
                  <>
                    <p>
                      {i18next.t('Assign a score to this component')}
                    </p>
                    <div className="icon-cont">
                      <WarningFilled
                        style={{ color: 'var(--color-primary-70)' }}
                      />
                    </div>
                  </>
                )}
              </div>
              <div style={{ flex: 1 }}>
                {(options || []).map(o => {
                  const color = colors[o.value];
                  return <Radio key={o.value} value={o.value}>
                    <div className="left">
                      <div className="cont">
                        {renderPolygons({ value: o.value, color })}
                      </div>
                      <div className="description">
                        <div className="radio-title">
                          {o.label}
                        </div>
                        {o.description ? <div className="radio-description">
                          {o.description}
                        </div> : null}
                      </div>
                    </div>
                  </Radio>
                })}
              </div>
            </div>
          </Radio.Group >
        );
      default:
        return (
          <Radio.Group value={value} {...props}>
            {(options || []).map(o => {
              return <Radio key={o.value} value={o.value}>
                <div className="radio-title">
                  {o.label}
                </div>
                {o.description ? <div className="radio-description">
                  {o.description}
                </div> : null}
              </Radio>
            })}
          </Radio.Group>
        );
    }
  },
  checkboxGroup: ({ props, value, options, restricted, autocomplete, formsValue, repeatIndex, name, inputName, replace }, { form, setFormValues, add, remove }) => {
    return (
      <Checkbox.Group value={value} {...props}>
        {(options || []).map(o => {
          return <Checkbox key={o.value} value={o.value}>
            <span className="radio-title">
              {o.label}
            </span>
            {o.description ? <span className="radio-description">
              {o.description}
            </span> : null}

          </Checkbox>
        })}
      </Checkbox.Group>
    );
  },
  total100: ({ props, name, options, value }, { form }) => {
    value = value ? (Array.isArray(value) ? value : [value]) : []
    function totalValue() {
      let total = 0;
      (value || []).forEach(v => {
        total += v.value || 0;
      });
      return total;
    }
    function siblingTotal(type) {
      const siblingValues = value
        .filter(v => v.type !== type)
        .map(v => v.value)
      if (!siblingValues.length) {
        return 0;
      }
      if (siblingValues.length === 1) {
        return siblingValues[0];
      } else {
        return siblingValues.reduce((a, b) => a + b);
      }
    }

    return <div className="total100">
      <Form.List key={name} name={name}>
        {(fields, { add, remove }) => {
          if (fields.length === 0) {
            const formData = value || [];
            if (formData.length) {
              formData.forEach(f => {
                add(f);
              })
            } else {
              add({ type: null, value: null })
            }
          }
          return <React.Fragment>
            {fields.map((field, i) => {
              const v = value[field.name] || {};
              return <Space className="total" key={i}>
                <Form.Item
                  noStyle
                  {...field}
                  name={[field.name, 'type']}
                  fieldKey={[field.fieldKey, 'type']}
                  initialValue={v.type || null}>
                  <Select
                    size="large"
                    {...getPopupContainer()}
                    allowClear
                    showSearch
                    filterOption={filterSelectOptions}
                    optionFilterProp="children" {...props}>
                    {options.map((option, i) =>
                      <Select.Option value={option.value} key={i}>
                        {option.label}
                      </Select.Option>
                    )}
                  </Select>
                </Form.Item>
                <Form.Item
                  noStyle
                  {...field}
                  name={[field.name, 'value']}
                  fieldKey={[field.fieldKey, 'value']}
                  initialValue={v.value}>
                  <InputNumber
                    size="large"
                    allowClear
                    name="value"
                    formatter={value => {
                      return value ? `${value}%` : '';
                    }}
                    disabled={!v.type || null}
                    placeholder={props.valueplaceholder ? props.valueplaceholder : 'Value'}
                    min={1}
                    max={100 - siblingTotal(v.type || 0)}
                  />
                </Form.Item>

                {(fields.length - 1) === i ? <Button disabled={!v.value || !v.type || totalValue() >= 100} type="primary" icon={<PlusOutlined />} onClick={() => {
                  if ((value.map(v => v.value).reduce((a, c) => a + c) < 100) && value[i].type) {
                    add({ type: null, value: null })
                  }
                }} /> : null}
                {i < (fields.length - 1) ? <Button type="danger" icon={<DeleteOutlined />} onClick={() => {
                  remove(field.name);
                  if (fields.length === 1) {
                    add({});
                  }
                }} /> : null}

              </Space>
            }
            )}
          </React.Fragment>

        }}
      </Form.List>
      {(totalValue() > 100) ? <span className="error">The total fields value must be 100%</span> : null}
    </div>

  },
  percentage: ({ name, inputName, totalMax, repeatIndex, props, formsValue }, { inputMeta }) => {
    const isRepeatable = Array.isArray(formsValue[name]);
    let totalSiblings = 0;
    if (isRepeatable) {
      totalSiblings = (formsValue[name] || [])
        .filter((g, idx) => idx !== repeatIndex)
        .reduce((totl, grp) => {
          totl = totl + (grp[inputName] || 0);
          return totl;
        }, 0);
    }
    return <InputNumber
      size="large"
      allowClear
      {...props}
      disabled={props.disabled || inputMeta.notApplicable || inputMeta.notAvailable}
      placeholder={getMetaPlaceholer(inputMeta) || props.placeholder || i18next.t('Type number')}
      min={0}
      max={totalMax ? (isRepeatable ? (100 - totalSiblings) : 100) : 100}
      formatter={value => {
        return value ? `${value}%` : '';
      }}
      parser={value => value.replace('%', '')}
      addonAfter="%"
    />
  },
  year: ({ props }) => {
    const lng = localStorage.getItem('datastakeLng') || 'en';
    return <DatePicker
      size="large"
      allowClear
      locale={lng === 'fr' ? localeFr : localeEn}
      picker="year"
      {...props}
      format="YYYY" />
  },
  upload: ({ props, rules, value, name, inputName, repeatIndex, repeatValues, formsValue }, { form, setFormValues, setLoading }) => {
    const apiURL = getApiBaseUrl();
    const accept = rules.length ? (rules.find(rule => Object.keys(rule).includes('accept')).accept || '*') : null;
    const values = (
      Array.isArray(value) ? value :
        (
          value &&
            typeof value === 'object' &&
            value.fileList &&
            Array.isArray(value.fileList) ?
            value.fileList.map(f => f.response).filter(f => f) : []
        )
    ) || [];

    const maxRule = rules.find(r => r.max);
    const maxProps = {};
    if (maxRule) {
      maxProps.maxCount = maxRule.max;
      if (maxRule.max > 1) {
        maxProps.multiple = true;
      }
    }
    return <Upload.Dragger
      {...maxProps}
      accept={accept}
      action={`${apiURL}/upload`}
      headers={{
        Authorization: `Bearer ${getToken()}`,
        ...getAppHeader(),
      }}
      defaultFileList={values}>
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">
        {i18next.t('Click or drag file to this area to upload')}
      </p>
      <p className="ant-upload-hint">
        {i18next.t('Support for a single or bulk upload.')}
      </p>
    </Upload.Dragger>
  },

  imageUpload: ({ props, rules, value, name, inputName, repeatIndex, repeatValues, formsValue }, { form, setFromValues, setLoading = () => { }, ...others }) => {
    const apiURL = getApiBaseUrl();
    const values = getImageUploadEditValue(value)
    const maxRule = rules.find(r => r.max);
    const maxProps = {};
    if (maxRule) {
      maxProps.maxCount = maxRule.max;
      if (maxRule.max > 1) {
        maxProps.multiple = true;
      }
    }

    return <Upload
      {...maxProps}
      accept="image/*"
      classList={!values || !values.length ? 'empty' : ''}
      listType="picture-card"
      action={`${apiURL}/upload`}
      headers={{
        Authorization: `Bearer ${getToken()}`,
        ...getAppHeader(),
      }}
      defaultFileList={values}
      type="select"
      onChange={(e) => {
        if (e.file && e.file.status && typeof setLoading === 'function') {
          if (e.file.status === 'uploading') {
            setLoading(true);
          } else {
            setLoading(false);
          }
        }
      }}
    >
      <div style={{ width: '100%' }}>
        <PlusOutlined />
        <div>{i18next.t('Upload')}</div>
      </div>
    </Upload>
  },
  geolocation: ({ value, name, inputName, repeatIndex, props, formsValue, addressData }, { form, inputMeta }) => {
    let search = formsValue.country;
    if (addressData && Object.keys(addressData).length > 0) {
      if (addressData.country) {
        search = addressData.country;
      }
      if (addressData.level1) {
        search = `${addressData.level1}, ${addressData.country}`;
      }
      if (addressData.level2) {
        search = `${addressData.level2}, ${addressData.level1}, ${addressData.country}`;
      }
    } else {
      const country = countries[formsValue.country] || {};
      if (country) {
        search = country.name;
      }
      if (formsValue.administrativeLevel1Name) {
        search = `${search} ${formsValue.administrativeLevel1Name}`
      }
      if (formsValue.administrativeLevel2Name) {
        search = `${search} ${formsValue.administrativeLevel2Name}`
      }
    }
    return <Geolocation
      inputMeta={inputMeta}
      disabled={props.disabled || inputMeta.notApplicable || inputMeta.notAvailable}
      size="large"
      allowClear={true}
      name={name}
      val={value || {}}
      searchValue={search}
    />
  },
  ajaxSelect: ({
    call,
    automaticallyLink,
    name,
    inputName,
    props,
    formsValue,
    onNewSetValue,
    multiple,
    updateOptions,
    repeatValues,
    repeatIndex,
    updateOtherFields,
    disableOtherFields,
    value,
    unique,
    address,
    addressData = {},
    getFromLinking,
  }, { form, forms, setAddress, changeInputMeta, inputMeta, meta }) => {
    return <AjaxSelect
      size="medium"
      allowClear={true}
      call={call}
      automaticallyLink={automaticallyLink}
      name={name}
      unique={unique}
      changeInputMeta={changeInputMeta}
      inputName={inputName}
      value={value}
      meta={meta}
      props={props}
      formsValue={formsValue}
      inputMeta={inputMeta}
      mainForm={form}
      repeatIndex={repeatIndex}
      repeatValues={repeatValues}
      onNewSetValue={onNewSetValue}
      multiple={multiple}
      getFromLinking={getFromLinking}
      updateOptions={updateOptions}
      onOptions={(options) => {
        if (propHasValue(repeatIndex)) {
          forms[name].inputs[inputName].options = options
        } else {
          forms[name].options = options
        }
      }}
      onChange={(ev, data) => {
        if (propHasValue(ev)) {
          const selectedValue = data.find(v => v.value === ev);
          if (address && selectedValue) {
            dot.str(address, selectedValue.label, addressData);
            setAddress({
              ...addressData
            })
          }
        }
      }}
      addressData
      setAddress
      address
    />
  },
  tag: ({ value, name, repeatLabel, inputName, repeatIndex, repeatValues, formsValue }, { form, setFormValues }) => {
    return <Tag size="large" allowClear={true} value={value || []} newPlaceholder={repeatLabel} />
  },
  modal: ({
    call,
    automaticallyLink,
    name,
    inputName,
    props,
    formsValue,
    allFormsValue,
    onNewSetValue,
    repeatValues,
    repeatIndex,
    value,
    modalTitle,
    buttonText,
    totalInputs,
    shownInputs,
    allowDupplicates,
  }, { form, setFormValues, add }) => {
    return <AjaxModal
      allowClear={true}
      call={call}
      add={add}
      automaticallyLink={automaticallyLink}
      name={name}
      inputName={inputName}
      value={value}
      props={props}
      formsValue={formsValue}
      allFormsValue={allFormsValue}
      mainForm={form}
      repeatIndex={repeatIndex}
      repeatValues={repeatValues}
      onNewSetValue={onNewSetValue}
      modalTitle={modalTitle}
      buttonText={modalTitle}
      totalInputs={totalInputs}
      shownInputs={shownInputs}
      allowDupplicates={allowDupplicates}
      onChange={(ev) => {
      }} />
  },
  dataLink: ({
    setValues,
    name,
    onValuesChange,
    changeLinking,
    formsValue,
    input,
  }, { form }) => {
    const isSingle = input?.meta?.maxRepeat === 1;
    const formData = isSingle ? (formsValue[name] ? [{ ...formsValue[name] }] : [])
      : (formsValue[name] || []).map((v, i) => ({ ...v, key: i }));

    const onUpdate = (val, i) => {
      const _val = isSingle ? { [name]: val } : { [name]: formData.map((d, j) => i === j ? val : d) };
      onValuesChange(_val, { ...formsValue, ..._val });
      form?.setFieldValue(name, _val[name]);
      setValues({
        ...formsValue,
        ..._val,
      })
    }

    return (
      <DataLink
        form={input}
        changeLinking={changeLinking}
        onUpdate={onUpdate}
        values={formsValue}
        name={name}
        maxRepeat={input?.meta?.maxRepeat}
        remove={({ key }) => {
          const _val = isSingle ? { [name]: null } : { [name]: formData.filter((v) => v.key !== key) };
          onValuesChange(_val, { ...formsValue, ..._val });
          form?.setFieldValue(name, _val[name]);
          setValues({
            ...formsValue,
            ..._val,
          })
        }}
        add={(val) => {
          const _val = isSingle ?
            { [name]: val }
            : { [name]: [...formData, { ...val, key: formData.length }] };
          form?.setFieldValue(name, _val[name]);
          onValuesChange(_val, { ...formsValue, ..._val });
          setValues({
            ...formsValue,
            ..._val,
          })
        }}
        k={name}
        formData={formData}
      />
    );
  },
  website: ({ name, inputName, props, value, repeatIndex, repeatValues, formsValue }, { form }) => {
    return <Website size="large" allowClear={true} initialValue={value} {...props} onChange={val =>
      updateFormValues(repeatIndex, repeatValues, inputName, val, formsValue, name, form)
    } />
  },
  group: ({ props, name, groupInputs }, { form, inputMeta }) => {
    return <GroupInput groupInputs={groupInputs} inputMeta={inputMeta}  {...props} />
  },
  groupInputs: ({ props, name, groupInputs }, { form, inputMeta }) => {
    return <GroupInput groupInputs={groupInputs} inputMeta={inputMeta}  {...props} />
  },
  transfer: ({
    call,
    props,
    formsValue,
    allFormsValue,
    repeatValues,
    repeatIndex,
    value,
    template,
    optionGroup,
    measureOptions,
    locationName,
    ...other
  }, { inputLabel, onValuesChange, forms }) => {
    return <Transfer
      props={props}
      forms={forms}
      value={value}
      optionGroup={optionGroup}
      template={template}
      call={call}
      formsValue={formsValue}
      allFormsValue={allFormsValue}
      repeatValues={repeatValues}
      repeatIndex={repeatIndex}
      onValuesChange={onValuesChange}
      inputLabel={inputLabel}
      measureOptions={measureOptions}
      locationName={locationName}
    />
  }
}

export const filterForm = (f, d) => {
  return f && (f.showFormIf ? showHideForm(f, d) : true)
}
export const checkFormHasSubsections = (f = {}) => Object.keys(f)
  .map(key => propHasValue(f[key].subSection))
  .includes(true);

export const mapFormGroup = (f, d) => Object.keys(f).map(key => {
  const { label, description = '', excludeFromEdit, showFormIf, icon = '', position = 0, template, formClass, ...fc } = f[key] || {};
  const fConf = {
    id: key,
    label,
    description,
    icon,
    position,
    template,
    excludeFromEdit,
    showFormIf,
    formClass,
    show: filterForm(f[key], d),
    options: fc,
  };
  if (checkFormHasSubsections(f[key])) {
    fConf.items = groupSubForms(f[key], d)
  }
  return fConf;
}).sort((a, b) => (a.position || 0) - (b.position || 0));
export const groupSubForms = (fConf, d) => {
  return Object.keys(fConf).reduce((f, fKey) => {
    if (fConf[fKey].subSection) {
      let subName = fConf[fKey].subSection;
      if (typeof fConf[fKey].subSection === "object") {
        subName = fConf[fKey].subSection.name;
      }
      if (!f[subName]) {
        f[subName] = {
          label: '',
          icon: '',
          position: 0,
          options: {},
          formClass: undefined,
          show: filterForm(fConf[fKey], d),
        };
        if (typeof fConf[fKey].subSection === "object") {
          const { label = '', icon = '', position = 0, formClass } = fConf[fKey].subSection;
          f[subName] = {
            label,
            icon,
            position,
            options: {},
            formClass,
            show: filterForm(fConf[fKey].subSection, d),
          };
        }
      }
      Object.assign(f[subName].options, { [fKey]: fConf[fKey] });
    }
    return f;
  }, {})
}

export const GetFormItem = ({
  inputData,
  inputId,
  input,
  values,
  MainForm,
  options,
  plainForms,
  setValues,
  setAddress,
  i,
  inputKey,
  onValuesChange = () => { },
  template = 'DEFAULT',
  setLoading = () => { },
  inputMeta = {},
  changeInputMeta = () => { },
  changeLinking = () => { },
}) => {
  const [isShown, setIsShown] = useState(!!inputData.commentValue);
  const inputLabel = getInputLabel(input, values);

  switch (input.type) {
    case 'h1':
    case 'h2':
    case 'h3':
    case 'h4':
    case 'h5':
    case 'h6':
      return getInputHeadLines(input.type, i, input, values);
    case 'header':
      return (
        <div className="daf-title with-subtitle" style={input?.meta?.style}>
          <h1>{getLabel(input.label, values)}</h1>
          {input.subTitle ? (
            <p>{getLabel(input.subTitle, values)}</p>
          ) : null}
        </div>
      );
    case 'custom':
      return <Template conf={{
        input,
        values,
        ...(input.config || {})
      }}
        template={input.config.template}
        namespace="input"
      />;
    default:
      let rules = input.rules || inputData.rules;

      const requiredRule = rules.find((r) => r.required);

      let maxRule = rules.find((rule) => rule.max)?.max;

      if (!maxRule && input.type === 'textarea') {
        maxRule = MAX_TEXT_AREA_LENGTH;
      }

      if (!maxRule && input.type === 'text') {
        maxRule = MAX_TEXT_INPUT_LENGTH;
      }

      if (requiredRule && input.type === 'text') {
        rules.push({ whitespace: true, message: requiredRule.message || '' });
      }

      if (requiredRule) {
        if (input.type === 'groupInputs') {
          rules = rules.map((r) => {
            if (r.required) {
              return ({ getFieldValue }) => ({
                validator(_, value) {
                  if (inputMeta.notAvailable || inputMeta.notApplicable) {
                    return Promise.resolve();
                  }

                  const keys = Object.keys(input.inputs);

                  for (let i = 0; i < keys.length; i++) {
                    if (typeof getFieldValue(keys[i]) === 'undefined' || getFieldValue(keys[i]) === null) {
                      return Promise.reject(r.message);
                    }
                  }

                  return Promise.resolve();
                },
              });
            }

            return r;
          });
        } else {
          rules = rules.map((r) => {
            if (r.required) {
              return ({ getFieldValue }) => ({
                validator(_, value) {
                  if (inputMeta.notAvailable || inputMeta.notApplicable) {
                    return Promise.resolve();
                  }

                  if (!value) {
                    return Promise.reject(r.message);
                  }

                  return Promise.resolve();
                },
              });
            }

            return r;
          });
        }
      }

      if (input && typeof input === 'object') { // check if input is valid
        return <>
          <div className="flex-row input-cont">
            <Form.Item
              {...(inputOnBlur.includes(input.type) ? { trigger: "onBlur" } : {})}
              {...(['total100', 'group'].includes(input.type) ? {} : {
                name: inputId,
                fieldKey: inputId,
                initialValue: inputData.value,
              })}
              {...(['upload'].includes(input.type) ? {
                valuePropName: "fileList",
                getValueFromEvent: (e) => {
                  if (Array.isArray(e)) {
                    return e;
                  }
                  return e && e.fileList && e.fileList.map(f => {
                    if (f.response) {
                      return f.response;
                    }
                    return f;
                  })
                }
              } : {
              })}
              className={formatClassname([
                `i-${input.type} flex-1`,
                input.comment && 'with-comment',
                maxRule && 'with-max-rule',
              ])}
              data-id={inputData.name}
              rules={rules}
              required={
                inputData.rules && inputData.rules instanceof Array &&
                  inputData.rules.filter(r => r.required).length > 0 ? true : false
              }
              labelCol={12}
              label={(
                <div className="flex">
                  <div className="mr-1">
                    {getInputLabel(input, values)}
                  </div>
                </div>
              )}>
              {
                inputTypeComponent[input.type]
                  ? inputTypeComponent[input.type](inputData, {
                    form: MainForm,
                    forms: options,
                    allForms: plainForms,
                    setFormValues: setValues,
                    setAddress,
                    changeInputMeta,
                    inputLabel,
                    changeLinking,
                    onValuesChange,
                    setLoading,
                    inputMeta,
                    meta: input.meta,
                  }) : console.log(input)
              }
            </Form.Item>
            {/* // TODO: Check if should show this cont */}
            <div
              className={formatClassname([
                "ml-4 input-actions",
                smMtInputs.includes(input.type) ? 'mt-5' : 'mt-10',
              ])}>
              <Button
                className={formatClassname(["default p-0", inputMeta.notApplicable && 'primary'])}
                type="link"
                onClick={() => {
                  const value = getDefaultInputValue(input);
                  MainForm.setFields([{ name: inputKey, value }]);
                  changeInputMeta({
                    key: inputKey,
                    type: input.type,
                    value: inputMeta.notApplicable ?
                      { notApplicable: false, notAvailable: false }
                      : { notApplicable: true, notAvailable: false },
                    otherValues: { [inputKey]: value },
                  })
                }}
                disabled={!input.meta?.notApplicable}
              >
                <CustomIcon name="NotApplicable" width={16} height={16} />
              </Button>

              <Button
                className={formatClassname(["default p-0", inputMeta.notAvailable && 'primary'])}
                type="link"
                disabled={!input.meta?.notAvailable}
                onClick={() => {
                  const value = getDefaultInputValue(input);
                  MainForm.setFields([{ name: inputKey, value: value }]);
                  changeInputMeta({
                    key: inputKey,
                    type: input.type,
                    value: inputMeta.notAvailable
                      ? { notAvailable: false, notApplicable: false }
                      : { notAvailable: true, notApplicable: false },
                    otherValues: { [inputKey]: value },
                  })
                }}
              >
                <CustomIcon name="NotAvailable" width={16} height={16} />
              </Button>

              <Button
                type="link"
                disabled={!input.meta?.comment}
                {...(!isShown
                  ? { className: 'default p-0' }
                  : { className: 'p-0 primary' })
                }
                onClick={() => {
                  setIsShown(true);
                  changeInputMeta({
                    key: inputKey,
                    type: input.type,
                    value: { comment: '' },
                  })
                }}>
                <CustomIcon name="AddComment" width={16} height={16} />
              </Button>

            </div>


            {input.meta?.code ? (
              <div className="code">
                <span>{input.meta?.code}</span>
              </div>
            ) : null}
          </div>

          {maxRule ? ['imageUpload', 'upload'].includes(input.type) ? (
            <div className="mt-2">
              <div className="max-char-cont">
                <span className="max-char-span">
                  {i18next.t('max-items', { chars: maxRule })}
                </span>
              </div>
            </div>
          ) : (
            <div className="max-char-cont" >
              <span className="max-char-span">
                {i18next.t('max-char', { chars: maxRule })}
              </span>
            </div>
          ) : null}

          {input.meta?.comment && isShown ?
            <div className="input-content">
              <Form.Item
                className="comment-textarea"
                initialValue={inputData.commentValue}
                hidden={!isShown}
                label={(
                  <div className="flex w-100">
                    <div className="flex-1">
                      {i18next.t('Comment')}
                    </div>
                    <Popconfirm
                      placement="left"
                      title={i18next.t('Are you sure you want to delete this comment?')}
                      onConfirm={() => {
                        setIsShown(false);
                        changeInputMeta({
                          key: inputKey,
                          type: input.type,
                          value: { comment: null },
                        })
                      }}
                    >
                      <Button
                        type="link"
                        disabled={!input.meta?.comment}
                        className="p-0"
                      >
                        <DeleteOutlined width={16} height={16} />
                      </Button>
                    </Popconfirm>
                  </div>
                )}
              >
                {inputTypeComponent.comment(inputData, {
                  form: MainForm,
                  forms: options,
                  setFormValues: setValues,
                  value: inputData.commentValue,
                  onChange: (val) => {
                    changeInputMeta({
                      key: inputKey,
                      type: input.type,
                      value: { comment: val },
                    })
                  }
                })}
              </Form.Item>
              <span className="max-char-span">
                {i18next.t('max-char', { chars: MAX_COMMENTS_LENGTH })}
              </span>
            </div>
            : null}
        </>
      }

      return null;
  }
}

export const prepareData = ({ data, form = [] }) => {
  // const dataLinkObjects = [];

  // form.forEach(({ options }) => {
  //   Object.keys(options || {}).forEach((key) => {
  //     const config = options[key];

  //     if (config?.type === 'dataLink') {
  //       dataLinkObjects.push({ ...config, key });
  //     }
  //   })
  // });

  // const mapOption = (data, input) => {
  //   const key = input?.meta?.linkingKey;
  //   if (data[key]) {
  //     if (data[key] !== 'new') {
  //       return data[key];
  //     }
  //   }

  //   return data;
  // };

  // dataLinkObjects.forEach((opt) => {
  //   if (data[opt.key]) {
  //     if (Array.isArray(data[opt.key])) {
  //       data[opt.key] = data[opt.key].map((d) => mapOption(d, opt));
  //     } else {
  //       data[opt.key] = mapOption(data[opt.key], opt);
  //     }
  //   }
  // });

  return data;
}
